import script from "./NewsPageBodyNewsfeedItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyNewsfeedItem.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyNewsfeedItem.vue?vue&type=style&index=0&id=7007a4ca&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7007a4ca"]])

export default __exports__